import { MailOutline } from "@material-ui/icons";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/Commission/create.js";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import { bookingApi } from "functions/apis";
import CustomInput from "components/CustomInput/CustomInput";
import FeePolicyDetailList from "./FeePolicyDetailList";

const useStyles = makeStyles(styles);

const defaultState = {
  code: "",
  description: ""
};

export default function Edit(props) {
  const [redirect, setRedirect] = useState(false);
  const [state, setState] = useState({ ...defaultState });
  const [disabled, setDisabled] = React.useState(false);

  const { id } = useParams();

  const abortController = React.useRef(new AbortController());

  const getFeePolicyData = () => {
    bookingApi
      .get("FeePolicies/" + id, {
        signal: abortController.current.signal
      })
      .then(data => {
        setState({
          ...state,
          code: data.code,
          description: data.description
        });
      })
      .catch(error => console.log(error));
  };

  useEffect(() => {
    getFeePolicyData();
    return () => {
      abortController.current.abort();
    };
  }, []);

  const handleCodeChanged = e => setState({ ...state, code: e.target.value });

  const handleDescriptionChanged = e =>
    setState({ ...state, description: e.target.value });

  const handleSubmit = () => {
    setDisabled(true);
    bookingApi
      .put("/FeePolicies/" + id, state, {
        signal: abortController.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to={"/admin/FeePolicy/InDraft"} />
  ) : (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>EDIT FEE POLICY</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <GridContainer>
              <GridItem xs={12} md={12}>
                <CustomInput
                  labelText="Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleCodeChanged,
                    value: state.code ?? ""
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={12}>
                <CustomInput
                  labelText="Description"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleDescriptionChanged,
                    value: state.description ?? ""
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={12}>
                <Button
                  disabled={disabled}
                  color="rose"
                  type="submit"
                  value="Submit"
                  onClick={() => handleSubmit()}
                >
                  Update
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        <FeePolicyDetailList isDelete={false} id={id} status={0} />
      </GridItem>
    </GridContainer>
  );
}

Edit.propTypes = {
  history: PropTypes.object
};
